
const sdu_env = window.sdu_env;
export default sdu_env;
